// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1W0p3","head":"Table_head__3x9XV","col":"Table_col__3VX8m"};